import Modal from "./modal";
import Swiper, { Pagination, Autoplay } from "swiper";


export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.nav();
        this.swiper();
        this.modal = new Modal();
    }

    nav() {
        const $trigger = document.querySelector(".js-menu__open");
        const $close = document.querySelectorAll(".js-menu__close");
        const $menu = document.querySelector(".js-menu");

        const $underbg = document.querySelector(".underbg");

        $trigger.addEventListener("click", () => {
            if (!$trigger.classList.contains("-active")) {
                $menu.classList.add("-active");
                $trigger.classList.add("-active");
                $underbg.style.top = window.pageYOffset + "px";
            } else {
                $menu.classList.remove("-active");
                $trigger.classList.remove("-active");
            }
        });

        $close.forEach((el) => {
            el.addEventListener("click", () => {
                $menu.classList.remove("-active");
                $trigger.classList.remove("-active");
            });
        });
    }
    
    swiper() {
        Swiper.use([Pagination, Autoplay]);
        const swiper = new Swiper(".swiper-container", {
            // Optional parameters
            loop: true,
            speed: 1000,
            autoplay: false,

            // If we need pagination
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
        });
    }
}
